import {
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { createUserSocket } from "../utils/userSocket";
import { resetOrderCreation } from "../redux/retailerWholesalerOrderActions";
import { resetShippingCost } from "../redux/shippingCostRedux";
import useBlockBackNavigation from "../hooks/useBlockBackNavigation";
import Navbar from "../components/Navbar";
import OrderConfirmation from "../components/Order/OrderConfirmation";
import { clearCart } from "../redux/retailerWholesalerCartSlice";

// ─────────────────────────────────────────────────────────────────────────────
// Rams-optimized RW COD order summary — same shell as CODOrderScreen
// (/orderPage): narrow centered column, success-first hierarchy, borderless
// item rows, quiet details, live tracking, sticky total + Continue Shopping.
// Also migrated off the legacy `/mobile/:userId/stream` SSE (stale-snapshot
// endpoint) onto the platform's Socket.IO orderRoom/orderUpdate pattern,
// filtered to THIS order, with the FULL delivery_status enum mapped (the old
// mapping sent ASSIGNED/PICKED_UP/… to "Order Cancelled").
// PRESENTATION + TRANSPORT ONLY — order source, fee/total math and the
// continue-shopping resets are unchanged.
// ─────────────────────────────────────────────────────────────────────────────

const CODRetailerWholesalerOrderScreen = () => {
  const user = useSelector((state) => state.user.currentUser);
  const userId = user?.result?._id || user?._id;

  const { order } = useSelector((state) => state.retailerWholesalerOrder);

  // Show the total the server actually charged for THIS order (authoritative
  // distance-based fee/total on the created order). The legacy flat `/shippingCost`
  // slice is no longer used for the charged amount. Prefer order.totalPrice,
  // falling back to itemsPrice + order.deliveryFee for older order shapes.

  const dispatch = useDispatch();
  const history = useHistory();

  // Back must not return into the checkout flow (double-order protection).
  useBlockBackNavigation("/");

  const handleContinueShopping = () => {
    dispatch(clearCart());
    dispatch(resetOrderCreation());
    dispatch(resetShippingCost());
    setTrackOrder({});
    history.push("/");
  };


  // Active Step

  // getStepContent

  const [trackOrder, setTrackOrder] = useState();
  const orderId = order?._id;

  // ── Live order tracking over Socket.IO (same pattern as CODOrderScreen /
  // MyProfile / OrderDetail): join `orderRoom:${client_id}`; the backend Mongo
  // change stream emits `orderUpdate` (full order doc) on every order write;
  // act ONLY on updates for THIS order. Replaces the legacy SSE that re-sent a
  // stale snapshot of the LATEST order every 10 s.
  useEffect(() => {
    if (!userId || !orderId) return;

    // Carries the customer's token: their rooms need it (utils/userSocket.js).
    const socket = createUserSocket();

    socket.on("connect", () => {
      console.log("[RWOrder] Socket connected, joining order room…");
      socket.emit("join", `orderRoom:${userId}`);
    });

    socket.on("orderUpdate", (updatedOrder) => {
      if (String(updatedOrder?._id) !== String(orderId)) return;
      console.log(
        "[RWOrder] orderUpdate:",
        updatedOrder?._id,
        updatedOrder?.delivery_status
      );
      setTrackOrder(updatedOrder);
    });

    socket.on("disconnect", () => {
      console.log("[RWOrder] Socket disconnected");
    });

    return () => {
      socket.off("orderUpdate");
      socket.disconnect();
    };
  }, [userId, orderId]);


  // ── Display helpers (presentation only) ──────────────────────────────────
  // Rams-honest tracking: "Cancelled" only appears when the order IS cancelled.

  return (
    <>
      <Navbar />
      <OrderConfirmation
        /* Live socket doc when we have one, else the created order.
           trackOrder starts as {} and is replaced on `orderUpdate`, so
           gate on _id rather than truthiness. */
        order={trackOrder?._id ? trackOrder : order}
        paymentLabel={"Cash on delivery"}
        onContinueShopping={handleContinueShopping}
      />
    </>
  );
};

export default CODRetailerWholesalerOrderScreen;
